var React = require('react');

function IconUser (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_15089","data-name":"Group 15089","transform":"translate(0)"},React.createElement("path",{"id":"Path_1225","data-name":"Path 1225","d":"M15.838,12a9.242,9.242,0,0,0-3.526-2.211,5.364,5.364,0,1,0-6.07,0A9.293,9.293,0,0,0,0,18.556H1.45a7.828,7.828,0,1,1,15.656,0h1.45A9.217,9.217,0,0,0,15.838,12ZM9.278,9.278a3.914,3.914,0,1,1,3.914-3.914A3.919,3.919,0,0,1,9.278,9.278Z","transform":"translate(0)","fill":"#211e1e"})));
}

IconUser.defaultProps = {"id":"user_2_","data-name":"user (2)","viewBox":"0 0 18.556 18.556"};

module.exports = IconUser;

IconUser.default = IconUser;
